export default __webpack_public_path__ + "static/media/time-picker-logo.9eb7d760.svg";